import Timer from '~/client/shared/Timer';
import type { TournamentFragment } from '../../../../graphql/TournamentFragment.generated';

type Props = {
  tournament?: TournamentFragment;
  isGameBanner?: boolean;
};

const useTimerCounter = ({ tournament }: Props) => {
  const endDate =
    tournament?.activityType === 'current'
      ? tournament?.closeAt
      : tournament?.openAt;
  const zeroed = tournament?.activityType === 'past';

  return {
    endDate,
    zeroed,
    status: tournament?.activityType as TournamentStatus,
    won: tournament?.myScore?.canClaimPrize,
  };
};

const TournamentTimer: FC<Props> = ({ tournament }) => {
  const { endDate, zeroed } = useTimerCounter({ tournament });
  return (
    <div className="grid gap-1">
      <Timer
        endDate={endDate}
        zeroed={zeroed}
        color="text-bulma"
        bannerType="default"
      />
    </div>
  );
};

export default TournamentTimer;
